(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Filters submit on change rather than behind an Apply button: the result set is the
     feedback, and an Apply button asks the customer to confirm a decision they have
     already made. */
  (function () {
    const form = document.getElementById('il-filter');
    if (!form) return;

    /* The sort control's visible label follows the select under it. Coming back to
       this page, the browser restores the select to what was last picked here, which
       is the order of the page that was left for, not of this one: put back this
       page's own. */
    const sortNow = form.querySelector('[data-sort-now]');
    const sortList = form.querySelector('[name="sort_by"]');
    const showSort = () => {
      const chosen = sortList && sortList.selectedOptions[0];
      if (sortNow && chosen) sortNow.textContent = chosen.textContent.trim().toUpperCase();
    };
    addEventListener('pageshow', () => {
      if (!sortList) return;
      [...sortList.options].forEach((option) => { option.selected = option.defaultSelected; });
      showSort();
    });

    form.addEventListener('change', (e) => {
      const label = e.target.closest('.cfilter');
      if (label) label.toggleAttribute('data-on', e.target.checked);
      if (e.target === sortList) showSort();

      const params = new URLSearchParams();
      const name = document.querySelector('[data-collection-name]')?.value.trim();
      if (name && /^[A-Za-z]{1,12}$/.test(name)) params.set('preview_name', name);
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((i) => {
        params.append(i.name, i.value);
      });
      const sort = form.querySelector('[name="sort_by"]');
      if (sort && sort.value) params.set('sort_by', sort.value);

      location.search = params.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-finder"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-finder]');
    if (!root) return;

    const quiz = root.querySelector('[data-gf-quiz]');
    const steps = [...root.querySelectorAll('[data-gf-step]')];
    const result = root.querySelector('[data-gf-result]');
    const grid = root.querySelector('[data-gf-grid]');
    const items = [...root.querySelectorAll('[data-gf-item]')];
    const countEl = root.querySelector('[data-gf-count]');
    const widenedEl = root.querySelector('[data-gf-widened]');

    const picked = [];
    let at = 0;

    const show = (i) => {
      steps.forEach((s, n) => s.toggleAttribute('hidden', n !== i));
      steps[i]?.querySelector('.gfh')?.focus({ preventScroll: true });
    };

    function matches(el, tags) {
      const own = (el.dataset.tags || '').split(',');
      return tags.every((t) => !t || own.includes(t));
    }

    function finish() {
      /* Widen back one answer at a time until something matches. A quiz that ends on an
         empty page has wasted the only three questions it was ever going to get - so it
         gives back the least specific answer first and says that it did. */
      let tags = picked.slice();
      let hits = items.filter((el) => matches(el, tags));
      let widened = false;

      while (hits.length === 0 && tags.length > 0) {
        tags = tags.slice(0, -1);
        hits = items.filter((el) => matches(el, tags));
        widened = true;
      }

      items.forEach((el) => el.toggleAttribute('hidden', !hits.includes(el)));
      const _one = countEl.dataset.one || 'design for them';
      const _other = countEl.dataset.other || 'designs for them';
      const _none = countEl.dataset.none || 'More designs are on the way';
      countEl.textContent = hits.length ? hits.length + ' ' + (hits.length === 1 ? _one : _other) : _none;
      root.querySelector('[data-gf-empty]').hidden = hits.length > 0;
      if (widenedEl) widenedEl.toggleAttribute('hidden', !widened);

      quiz.hidden = true;
      result.hidden = false;
      countEl.focus({ preventScroll: true });
      result.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    root.querySelectorAll('[data-gf-tag]').forEach((btn) => {
      btn.addEventListener('click', () => {
        picked[at] = btn.dataset.gfTag;
        at += 1;
        if (at >= steps.length) finish();
        else show(at);
      });
    });

    root.querySelectorAll('[data-gf-back]').forEach((btn) => {
      btn.addEventListener('click', () => {
        at = Math.max(0, at - 1);
        picked.length = at;
        show(at);
      });
    });

    const restart = root.querySelector('[data-gf-restart]');
    if (restart) {
      restart.addEventListener('click', () => {
        at = 0;
        picked.length = 0;
        result.hidden = true;
        quiz.hidden = false;
        show(0);
        quiz.scrollIntoView({ block: 'start' });
      });
    }
    if (!items.length || !steps.length) {
      if (restart) restart.hidden = true;
      finish();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const menu = document.getElementById('il-menu');
    const burger = document.querySelector('[data-menu-open]');
    if (!menu || !burger) return;
    let previousOverflow = '';

    const open = (on) => {
      if (on) menu.setAttribute('data-open', '');
      else menu.removeAttribute('data-open');
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) previousOverflow = document.body.style.overflow;
      document.body.style.overflow = on ? 'hidden' : previousOverflow;
      (on ? menu.querySelector('[data-menu-close]') : burger).focus();
    };

    burger.addEventListener('click', () => open(!menu.hasAttribute('data-open')));
    menu.querySelector('[data-menu-close]').addEventListener('click', () => open(false));

    document.addEventListener('keydown', (e) => {
      if (!menu.hasAttribute('data-open')) return;
      if (e.key === 'Escape') open(false);
      if (e.key === 'Tab') {
        const focusable = [...menu.querySelectorAll('a[href], button:not([disabled]), select')];
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    });

    /* Widening past the breakpoint hides the panel by CSS, but the scroll lock has to be
       released too or the desktop page is left unscrollable. */
    addEventListener('resize', () => {
      if (innerWidth >= 900 && menu.hasAttribute('data-open')) open(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"]) return;
  try {
    
  /* Cards start pointing at the sibling product page as-is. Once the shopper types
     a name in the personalization input, carry it along so "Review & add" opens
     already showing that name - the same preview_name convention the union
     renderer and cart-extras upsell already read. Letters only, matches the
     validation used everywhere else this query param is set. */
  (function () {
    const cards = document.querySelectorAll('[data-related-card]');
    if (!cards.length) return;

    const originals = new Map();
    cards.forEach((card) => originals.set(card, card.href));

    const input = document.querySelector('[data-text-input]');
    if (!input) return;

    function valid(name) {
      return /^[A-Za-z]{1,12}$/.test(name);
    }

    function apply() {
      const name = input.value.trim();
      const ok = valid(name);
      cards.forEach((card) => {
        const url = new URL(originals.get(card));
        if (ok) url.searchParams.set('preview_name', name);
        card.href = url.href;
      });
    }

    input.addEventListener('input', apply);
    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const form = document.getElementById('il-buy');
    if (!form) return;

    const dataEl = document.querySelector('[data-variant-data]');
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const textInput = document.querySelector('[data-text-input][form="il-buy"]') || form.querySelector('[data-text-input]');
    const countEl = document.querySelector('[data-count]');
    const dimEl = document.querySelector('[data-dim]');
    const stage = document.querySelector('[data-stage]');

    /* Legacy shaping for the character-count width estimate. The sprite engine has
       its own per-act shaping rules and owns the dimensions when an atlas is present. */
    const TERMINAL = {};
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach((c, i) => {
      TERMINAL[c] = String.fromCharCode(0xc0 + i);
    });

    function shape(raw) {
      let t = (raw || '').trim();
      if (!t) return '';
      t =
        t.length === 1
          ? t.toUpperCase()
          : t[0].toUpperCase() + t.slice(1, -1).toLowerCase() + t.slice(-1).toUpperCase();
      const last = t.slice(-1).toUpperCase();
      return t.slice(0, -1) + (TERMINAL[last] || last);
    }

    /* Fallback width estimate from configurable centimetres per character, capped
       by the section setting. It does not measure font outlines or baked geometry. */
    const NOMINAL_CM_PER_CHAR = parseFloat(form.dataset.cmPerChar) || 2.6;
    const MAX_CM = parseFloat(form.dataset.maxCm) || 23;

    function sizeFor(shaped) {
      if (!shaped) return 0;
      return Math.min(MAX_CM, shaped.length * NOMINAL_CM_PER_CHAR);
    }

    function currentOptions() {
      const opts = [];
      form.querySelectorAll('[data-opt-position][aria-pressed="true"]').forEach((b) => {
        opts[parseInt(b.dataset.optPosition, 10) - 1] = b.dataset.optValue;
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find((v) =>
        opts.every((val, i) => val === undefined || v.options[i] === val)
      );
    }

    /* As Liquid writes prices (window.ilMoney, snippets/il-i18n.liquid); the browser's
       own formatter only where that is missing. */
    function money(cents) {
      if (window.ilMoney) return window.ilMoney(cents);
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: form.dataset.currency || 'EUR',
      }).format(cents / 100);
    }

    function draw() {
      const raw = textInput ? textInput.value : '';
      const shaped = shape(raw);

      if (countEl && textInput) {
        countEl.textContent = raw.length + ' / ' + textInput.maxLength;
        countEl.className = 'cnt2' + (raw.length >= textInput.maxLength ? ' at' : '');
      }

      /* With the sprite engine on the page, the dimension comes from real baked
         millimetres - this per-character estimate must not race it, or the size the
         customer sees flickers between two numbers. */
      const spriteOwnsDim = !!document.querySelector('[data-sprite-config], [data-union-config]');
      const cm = sizeFor(shaped);
      if (dimEl && !spriteOwnsDim) dimEl.textContent = cm ? '≈ ' + Math.round(cm) + ' cm long' : '—';
      /* the sprite engine owns the bracket when present - same rule as the dim text */
      if (stage && !spriteOwnsDim) stage.style.setProperty('--objw', cm ? Math.round((cm / MAX_CM) * 88) + '%' : '60%');

      const nameEl = document.querySelector('[data-sb-name]');
      if (nameEl) nameEl.textContent = raw.trim() ? '“' + raw.trim() + '”' : '';
      const sizeEl = document.querySelector('[data-sb-size]');
      if (sizeEl && !spriteOwnsDim) sizeEl.textContent = cm ? '≈ ' + Math.round(cm) + ' CM LONG' : '';
    }

    if (textInput) textInput.addEventListener('input', draw);

    /* Colour and option chips drive the real variant, so the price, availability and
       what actually gets added to the cart all follow the swatch that is pressed. */
    form.querySelectorAll('[data-opt-position]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.optPosition;
        form
          .querySelectorAll('[data-opt-position="' + pos + '"]')
          .forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));

        const nameOut = form.querySelector('[data-pal-name="' + pos + '"]');
        if (nameOut) nameOut.textContent = btn.dataset.optValue.toUpperCase();

        const swatch = btn.dataset.optRole
          ? document.querySelector(btn.dataset.optRole === 'face' ? '[data-sb-face]' : '[data-sb-base]')
          : null;
        if (swatch) swatch.style.background = getComputedStyle(btn).backgroundColor;

        const variant = matchVariant(currentOptions());
        if (!variant) return;

        form.querySelector('[data-variant-id]').value = variant.id;
        document.querySelectorAll('[data-price]').forEach((el) => {
          el.textContent = money(variant.price);
        });
        /* The earlier price follows the colour too: shown only for a colour that is on
           sale (snippets/il-was.liquid). */
        const onSale = variant.compare_at_price > variant.price;
        document.querySelectorAll('[data-was]').forEach((el) => {
          el.hidden = !onSale;
          el.querySelector('[data-was-amount]').textContent = onSale ? money(variant.compare_at_price) : '';
        });

        document.querySelectorAll('.add, .buybar button, .sbright button').forEach((b) => {
          b.disabled = !variant.available;
        });

        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      });
    });

    /* Reveal the compact bar only once the real Add to cart has scrolled off the top, so
       the two are never on screen together asking for the same click. Measured on scroll
       rather than with IntersectionObserver: IO callbacks are driven by the rendering
       loop, so they silently never fire in a backgrounded or non-compositing tab - which
       is exactly the case where a regression would go unnoticed. */
    const sb = document.querySelector('[data-sticky-bar]');
    const addBtn = document.querySelector('.cta .add');
    if (sb && addBtn) {
      const sync = () => {
        sb.toggleAttribute('data-on', addBtn.getBoundingClientRect().bottom < 0);
      };
      addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', sync);
      sync();
    }

    /* Seed the swatches in the compact bar from whatever is pressed on load. */
    form.querySelectorAll('[data-opt-role][aria-pressed="true"]').forEach((b) => {
      const swatch = document.querySelector(
        b.dataset.optRole === 'face' ? '[data-sb-face]' : '[data-sb-base]'
      );
      if (swatch) swatch.style.background = getComputedStyle(b).backgroundColor;
    });

    draw();
  })();

  } catch(e) { console.error(e); }
})();
})();
